import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CURRENCY, PRICE_AMOUNT, PRICE_BEFORE } from '../data/musikkklar';
const recap = ['6 bind', '5 bonuser', '240 sider', '1.–10. trinn'];
const reassurances = ['Umiddelbar digital nedlasting', 'PDF klar til utskrift', '7 dagers fornøydgaranti'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="15fq5k1m7my3g">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1jasc8qyvsrhb" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t3g4r9itw9a8">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t4ra3drx9p3g">
          Musikkfaget kan være <em className="text-red-700" data-id="element-116" data-mp="22339o5arnx81">ferdig planlagt allerede i dag.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="1x4jj1rl89x9c">
          I stedet for å lete etter ideer, lage hvert opplegg selv og bruke søndagskveldene
          på planlegging, har du en organisert pakke for hele skoleåret. Mer tid til det som
          virkelig betyr noe:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x38ytrhg9u4b">
          Elevene dine. Undervisningen din. Livet ditt utenfor skolen.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="164gkna2s52hi">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b2i4hx8155u1">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/60" data-id="element-121" data-mp="1b171w0qbm44i">Før <s data-id="element-122" data-mp="1fvba0nbboi76">{PRICE_BEFORE}</s></p>
        <p className="mt-2 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fv1q9hgvf79x">
          {PRICE_AMOUNT}
          <span className="ml-2 font-sans text-2xl font-semibold tracking-normal text-slate-900/70 sm:text-3xl" data-id="element-124" data-mp="1psfumipis5lv">{CURRENCY}</span>
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-125" data-mp="1tuug7akkpjgu">Engangsbetaling – ingen abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-126" data-mp="3qvqhzqpxmujs">
          <CtaButton className="w-full sm:w-auto" data-id="element-127" data-mp="3qsb5mvnn7zm2" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-128" data-mp="3lx5khz22eoz1">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="3jfv6z29qun1">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-130" data-mp="3uupmja7r4pap" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}